export const featureList = [
  {
    title: "Analyze a language",
    desc:
      "Literacy Loom is language agnostic. It can be used with any alphabetic language, including endangered or underserved languages. English and Spanish language databases are included with the Literacy Loom SaaS."
  },
  {
    title: "Create a language database",
    desc:
      "Literacy Loom SaaS creates a language database that includes sounds (i.e., phonemes and their corresponding graphemes—letters or combinations of letters), words, phrases, and their frequencies."
  },
  {
    title: "Write culturally-bound stories",
    desc:
      "The language database is used to provide story-writing support. The software makes recommendations that follow evidence-based best practices and research. Literacy Loom suggests appropriate sequencing for the sounds, words and phrases that can be used in writing stories—with words limited to sounds that have already been taught—so story- writing is much easier. Connected sequences of stories—combined with practice activities and games that will be automatically generated by the Literacy Loom SaaS—can be used to teach reading, writing, spelling, and pronunciation skills."
  },
  {
    title: "Generate supports for teaching",
    desc:
      "Literacy Loom will generate instructional supports to assist parents/family, teachers, or peers who facilitate learning. Supports will include guidance to ensure appropriate implementation, prompts based on best-practices to maximize learner engagement, and assessments to measure student progress and ensure mastery of reading skills."
  },
  {
    title: "Produce beginning literacy curricula",
    desc:
      "The Literacy Loom SaaS will produce interactive mobile applications, games, and print materials that can be used to teach literacy skills. We recommend that learning include an adult or more advanced peer to optimize learning and minimize errors."
  }
];
